import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";
import { useToastStore } from "./toastStore";

const toneClasses = {
  neutral: "border-border",
  success: "border-emerald-500/40",
  danger: "border-red-500/40"
};

export function ToastViewport() {
  const toasts = useToastStore((s) => s.toasts);

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-2 pointer-events-none">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: 16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.97 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className={clsx(
              "glass pointer-events-auto rounded-xl border px-4 py-3 text-sm text-ink shadow-lifted",
              toneClasses[t.tone ?? "neutral"]
            )}
          >
            {t.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
